import EventEmitter from "eventemitter3";
import $ from "jquery";
import Swiper from "swiper";
import {Navigation} from "swiper/modules";
import 'swiper/css';

export class BuildingSelector extends EventEmitter {

  constructor(target) {
    super();

    this.$widget = target;

    // Use the first slide of slider to get the initial building type
    this.$firstSlide = this.$widget.find(".building-selector-slide").eq(0);
    this.currentBuilding = this.$firstSlide.attr("data-building-type");
    this.swiper = null;

    this.init();
  }

  init() {
    this.swiper = new Swiper(this.$widget.find(".building-selector-slider").get(0), {
      // Needed to make navigation work
      modules: [Navigation],

      slidesPerView: 'auto',
      centeredSlides: true,
      loop: false,
      threshold: 10,
      grabCursor: true,
      spaceBetween: 0,
      navigation: {
        prevEl: this.$widget.find('.swiper-button-prev').get(0),
        nextEl: this.$widget.find('.swiper-button-next').get(0),
      },

      on: {
        // Only trigger buildingChange when done swiping
        slideChange: (swiper) => {
          app.audio.play("audio/ButtonOnClick_260423.wav", 1, true)
          const slide = swiper.slides[swiper.activeIndex];
          const building = $(slide).attr("data-building-type");
          this.buildingChange(building);
        }
      }
    });
  }

  buildingChange(building) {
    // No change triggered if the building is exactly the same
    if (!building || building === this.currentBuilding) {
      return;
    }

    this.currentBuilding = building;
    this.change();
  }

  change() {
    this.emit('buildingChanged', this.currentBuilding);
  }

  /**
   * When we change Algorithm, reset to initial state before showing
   */
  reset() {
    this.currentBuilding = this.$firstSlide.attr("data-building-type");
    this.swiper.slideTo(0, 0);
    this.change();
  }
}
